import { ReactNode, useState } from 'react'
import { Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons'

const { Text } = Typography

type Props = {
  title: string
  children: ReactNode
}

const EducationBlock = ({ title, children }: Props) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div style={{ marginBottom: 16 }}>
      <Text
        type="secondary"
        style={{ cursor: 'pointer', fontSize: 13 }}
        onClick={() => setExpanded(!expanded)}
      >
        <FontAwesomeIcon icon={faCircleQuestion} style={{ marginRight: 6 }} />
        {title}
      </Text>
      {expanded && (
        <div
          style={{
            marginTop: 8,
            padding: '12px 16px',
            background: '#f5f5f5',
            borderRadius: 8,
            fontSize: 13,
            lineHeight: 1.6,
            color: '#595959',
          }}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default EducationBlock
